module.exports = __webpack_public_path__ + "img/bg_shapes.c24d4991.png";